import React, { useState, useEffect } from 'react'
import './TomConfigUserContainer.css'
import {
  getRolesUsers,
  getRolesList,
  postRolToUser,
  putRolToUser,
  deleteRolToUser,
  postLogTom,
} from '@auteco/services/tomService'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import MaterialTable from '@material-table/core'
import { getPermissions } from '@auteco/utils/Common'

const TomConfigUserContainer = () => {
  const [users, setUsers] = useState([])
  const [rolList, setRolList] = useState([])

  const permissions = getPermissions()

  const handleGetUsersRoles = async () => {
    const response = await getRolesUsers()
    setUsers(response.rolesUsuarios)
    await postLogTom({
      action: 'Entra configuracion de usuarios',
    })
  }

  const handleGetRolesList = async () => {
    const response = await getRolesList()
    setRolList(response.roles)
  }

  const handlePostRolToUser = async (body) => {
    const response = await postRolToUser(body)
    if (response) {
      console.log(response, 'Rol asignado')
      handleGetUsersRoles()
    }
  }

  const handlePutRolToUser = async (body) => {
    const response = await putRolToUser(body)
    if (response) {
      console.log(response, 'Rol actualizado')
      handleGetUsersRoles()
    }
  }

  const handleDeleteRolToUser = async ({ usuarioId, rolId }) => {
    const response = await deleteRolToUser({ usuarioId, rolId })
    if (response) {
      console.log(response, 'Rol eliminado')
      handleGetUsersRoles()
    }
  }

  useEffect(() => {
    handleGetUsersRoles()
    handleGetRolesList()
  }, [])

  const columns = [
    {
      title: 'Nombre',
      field: 'nombre',
      editable: 'never',
      render: (rowData) => `${rowData.nombre} ${rowData.apellido}`,
    },
    {
      title: 'Rol',
      field: 'rol_nombre',
      editComponent: ({ value, onChange }) => (
        <FormControl>
          <InputLabel>Rol</InputLabel>
          <Select
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
          >
            <MenuItem value="">
              <em>Sin asignar</em>
            </MenuItem>
            {rolList.map((rol) => (
              <MenuItem key={rol.id} value={rol.nombre}>
                {rol.nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
      render: (rowData) => rowData.rol_nombre || 'Sin asignar',
    },
  ]

  const handleRowUpdate = (newData, oldData) =>
    new Promise((resolve, reject) => {
      const body = {
        rolId: rolList.find((rol) => rol.nombre === newData.rol_nombre)?.id,
        usuarioId: newData.id,
        nombre: newData.nombre,
        correo: newData.correo,
        apellido: newData.apellido,
      }

      if (oldData.rol_nombre && newData.rol_nombre !== oldData.rol_nombre) {
        handlePutRolToUser(body).then(resolve).catch(reject)
      } else if (!oldData.rol_nombre && newData.rol_nombre) {
        handlePostRolToUser(body).then(resolve).catch(reject)
      } else {
        resolve()
      }
    })


    const handleRowUpdateFunction = async  (newData, oldData) =>{
      await postLogTom({
        action: `Edita un usuario ${oldData.id}`,
      })
      handleRowUpdate(newData, oldData)
    }
    

  const handleRowDelete = (oldData) =>
    new Promise((resolve, reject) => {
      const rolId = rolList.find((rol) => rol.nombre === oldData.rol_nombre)?.id
      if (rolId) {
        handleDeleteRolToUser({ usuarioId: oldData.id, rolId })
          .then(resolve)
          .catch(reject)
      } else {
        resolve()
      }
    })

    const handleRowDeleteFunction = async (oldData) =>{
      await postLogTom({
        action: `Elimina un usuario ${  oldData.id}`,
      })
      handleRowDelete(oldData)
    }


  if (permissions[74] === 5) {
    return (
      <div>
        <MaterialTable
          columns={columns}
          data={users}
          title="Usuarios TOM"
          options={{
            pageSize: 20,
            pageSizeOptions: [20, 50, 100],
            headerStyle: {
              backgroundColor: '#466eae',
              color: '#f1f1f1',
              fontSize: '10px',
              fontWeight: 700,
            },
            actionsColumnIndex: -1,
          }}
          editable={{
            onRowUpdate: handleRowUpdateFunction,
            onRowDelete: handleRowDeleteFunction,
          }}
        />
      </div>
    )
  }
  return (
    <div>
      <p>No tienes permisos para ver este contenido</p>
      <div>
        {/* Elemento que abre el widget al hacer clic */}
        <input placeholder="Search here" id="searchWidgetTrigger" />

        {/* Componente gen-search-widget */}
        <gen-search-widget
          configId="2c9abde8-788b-4a70-b6fc-dc4a8a1dae11"
          triggerId="searchWidgetTrigger"
        />
      </div>
    </div>
  )
}

export default TomConfigUserContainer
